import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { styled } from '@mui/material/styles';
import PlannedCalendarIndex from "../features/calendar/plannedCalendarIndex";
import WeekScheduleIndex from "../features/calendar/weekScheduleIndex";
import AssignToMachinesIndex from "../features/calendar/assignToMachinesIndex";
import CalendarMatrixIndex from "../features/calendar/calendarMatrixIndex";
import CalendarExceptionsIndex from "../features/calendar/calendarExceptionsIndex";
import messages from "../features/calendar/components/messages";
import { FormattedMessage } from "react-intl";

const CalendarPage = () => {
    const [tab, setTab] = useState(0);

    const StyledTabs = styled((props) => (

        <Tabs
            {...props}
            TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
        />
    ))({
        '& .MuiTabs-indicator': {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: 'transparent',
        },
        '& .MuiTabs-indicatorSpan': {
            width: '100%',
            backgroundColor: '#fff',
        },
    });

    const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
        ({ theme }) => ({

            textTransform: 'none',
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(20),
            marginRight: theme.spacing(0),
            minWidth: "150px",
            //backgroundColor: '#799c4a',
            color: 'rgba(255, 255, 255, 0.7)',
            '&.Mui-selected': {
                color: '#fff',
                backgroundColor: "#434957 !important",
            },
            '&.Mui-focusVisible': {
                backgroundColor: 'rgba(100, 95, 228, 0.32)',
            },
            '&.MuiTab-root': {
                backgroundColor: '#43495799',
                border: "1px solid #0c101b",
            },
        }),
    );

    return (
        <Box width="100%">
            <Box sx={{ borderBottom: 1, borderColor: "divider", ml: 2, mr: 2 }}>
                <StyledTabs value={tab} onChange={(e, v) => setTab(v)}>
                    <StyledTab label={<FormattedMessage {...messages.planningPerMonthTab} />} />
                    <StyledTab label={<FormattedMessage {...messages.weekTemplatesTab} />} />
                    <StyledTab label={<FormattedMessage {...messages.planTab} />} />
                    <StyledTab label={<FormattedMessage {...messages.machinePlanTab} />} />
                    <StyledTab label={<FormattedMessage {...messages.exceptionsTab} />} />
                </StyledTabs>
            </Box>
            <Box ml={2} mr={2}>
                {tab === 0 && <CalendarMatrixIndex />}
                {tab === 1 && <WeekScheduleIndex />}    
                {tab === 2 && <AssignToMachinesIndex />}
                {tab === 3 && <PlannedCalendarIndex />}
                {tab === 4 && <CalendarExceptionsIndex />}
            </Box>
        </Box>
    );
};

export default CalendarPage;